import { render, staticRenderFns } from "./tasksShow.vue?vue&type=template&id=56487f63&scoped=true"
import script from "./tasksShow.vue?vue&type=script&lang=js"
export * from "./tasksShow.vue?vue&type=script&lang=js"
import style0 from "./tasksShow.vue?vue&type=style&index=0&id=56487f63&prod&lang=scss&scoped=true"
import style1 from "./tasksShow.vue?vue&type=style&index=1&id=56487f63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56487f63",
  null
  
)

export default component.exports